import { render } from "./NoticeView.vue?vue&type=template&id=11cfac7c"
import script from "./NoticeView.vue?vue&type=script&lang=js"
export * from "./NoticeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userSupport/NoticeView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11cfac7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11cfac7c', __exports__)) {
    api.reload('11cfac7c', __exports__)
  }
  
  module.hot.accept("./NoticeView.vue?vue&type=template&id=11cfac7c", () => {
    api.rerender('11cfac7c', render)
  })

}


export default __exports__